import { render } from "./additionalTax.vue?vue&type=template&id=10573f3a&scoped=true"
import script from "./additionalTax.vue?vue&type=script&lang=js"
export * from "./additionalTax.vue?vue&type=script&lang=js"

import "./additionalTax.vue?vue&type=style&index=0&id=10573f3a&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10573f3a"]])

export default __exports__